export const DEFAULT_DELIVERY_HORIZON_DAYS = 15;

export const NO_DELIVERY_DAY_MESSAGE = `Aucun jour de livraison dans les ${DEFAULT_DELIVERY_HORIZON_DAYS} prochains jours`;

export const DRIVE_DELIVERY_SCHEDULE = '9H00 - 17H30';

export const DELIVERY_DATE_FORMAT = 'dddd D MMMM YYYY';

export const API_DATE_FORMAT = 'YYYY-MM-DD';
